import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Connections from './pages/Connections';
import Partners from './pages/Partners';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Jobs from './pages/Jobs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import TermsSellers from './pages/TermsSellers';
import Products from './pages/Products';
import ProductCatalog from './pages/ProductCatalog';
import ProductDetail from './pages/ProductDetail';
import Pricing from './pages/Pricing';
import Admin from './pages/Admin';
import Package from './pages/Package';
import LifetimeDiscountGroup from './pages/LifetimeDiscountGroup';
import BalanceTopup from './pages/BalanceTopup';
import Dashboard from './pages/Dashboard';
import SignInPage from './pages/SignInPage';
import SignUpPage from './pages/SignUpPage';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import ProtectedDashboardRoute from './components/ProtectedDashboardRoute';
import ClerkNotConfigured from './components/ClerkNotConfigured';
import './App.css';

const clerkPublishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

function App() {
  const clerkReady = Boolean(clerkPublishableKey);
  const authFallback = <ClerkNotConfigured />;

  return (
    <HelmetProvider>
      <Router>
        <LanguageProvider>
          <div className="App">
            <Routes>
              {/* Clerk: sign-in / sign-up - no header/footer; fallback when key missing */}
              <Route path="/sign-in" element={clerkReady ? <SignInPage /> : authFallback} />
              <Route path="/sign-up" element={clerkReady ? <SignUpPage /> : authFallback} />
              {/* Admin: only for users with role admin */}
              <Route path="/admin" element={clerkReady ? <ProtectedAdminRoute><Admin /></ProtectedAdminRoute> : authFallback} />
              {/* Dashboard: only for signed-in regular users (incl. localized) */}
              <Route path="/dashboard" element={clerkReady ? <ProtectedDashboardRoute><Dashboard /></ProtectedDashboardRoute> : authFallback} />
              <Route path="/dashboard/finance" element={clerkReady ? <ProtectedDashboardRoute><Dashboard /></ProtectedDashboardRoute> : authFallback} />
              <Route path="/dashboard/orders" element={clerkReady ? <ProtectedDashboardRoute><Dashboard /></ProtectedDashboardRoute> : authFallback} />
              <Route path="/dashboard/orders/:orderId" element={clerkReady ? <ProtectedDashboardRoute><Dashboard /></ProtectedDashboardRoute> : authFallback} />
              <Route path="/nl/dashboard" element={clerkReady ? <ProtectedDashboardRoute><Dashboard /></ProtectedDashboardRoute> : authFallback} />
              <Route path="/nl/dashboard/finance" element={clerkReady ? <ProtectedDashboardRoute><Dashboard /></ProtectedDashboardRoute> : authFallback} />
              <Route path="/nl/dashboard/orders" element={clerkReady ? <ProtectedDashboardRoute><Dashboard /></ProtectedDashboardRoute> : authFallback} />
              <Route path="/nl/dashboard/orders/:orderId" element={clerkReady ? <ProtectedDashboardRoute><Dashboard /></ProtectedDashboardRoute> : authFallback} />
              <Route path="/de/dashboard" element={clerkReady ? <ProtectedDashboardRoute><Dashboard /></ProtectedDashboardRoute> : authFallback} />
              <Route path="/de/dashboard/finance" element={clerkReady ? <ProtectedDashboardRoute><Dashboard /></ProtectedDashboardRoute> : authFallback} />
              <Route path="/de/dashboard/orders" element={clerkReady ? <ProtectedDashboardRoute><Dashboard /></ProtectedDashboardRoute> : authFallback} />
              <Route path="/de/dashboard/orders/:orderId" element={clerkReady ? <ProtectedDashboardRoute><Dashboard /></ProtectedDashboardRoute> : authFallback} />
              <Route path="/fr/dashboard" element={clerkReady ? <ProtectedDashboardRoute><Dashboard /></ProtectedDashboardRoute> : authFallback} />
              <Route path="/fr/dashboard/finance" element={clerkReady ? <ProtectedDashboardRoute><Dashboard /></ProtectedDashboardRoute> : authFallback} />
              <Route path="/fr/dashboard/orders" element={clerkReady ? <ProtectedDashboardRoute><Dashboard /></ProtectedDashboardRoute> : authFallback} />
              <Route path="/fr/dashboard/orders/:orderId" element={clerkReady ? <ProtectedDashboardRoute><Dashboard /></ProtectedDashboardRoute> : authFallback} />
              
              {/* All other routes with header/footer */}
              <Route path="*" element={
                <>
                  <Header />
                  <main style={{ marginTop: '64px' }}>
                    <Routes>
                      {/* English routes (default) */}
                      <Route path="/" element={<Home />} />
                <Route path="/connections" element={<Connections />} />
                <Route path="/partners" element={<Partners />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/jobs" element={<Jobs />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:productSlug" element={<ProductDetail />} />
                <Route path="/p" element={clerkReady ? <ProtectedAdminRoute><ProductCatalog /></ProtectedAdminRoute> : authFallback} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/terms-sellers" element={<TermsSellers />} />
                <Route path="/package" element={<Package />} />
                <Route path="/Lifetime-Discount-Group" element={<LifetimeDiscountGroup />} />
                
                {/* Dutch routes */}
                <Route path="/nl" element={<Home />} />
                <Route path="/nl/connections" element={<Connections />} />
                <Route path="/nl/partners" element={<Partners />} />
                <Route path="/nl/faq" element={<FAQ />} />
                <Route path="/nl/contact" element={<Contact />} />
                <Route path="/nl/jobs" element={<Jobs />} />
                <Route path="/nl/products" element={<Products />} />
                <Route path="/nl/products/:productSlug" element={<ProductDetail />} />
                <Route path="/nl/p" element={clerkReady ? <ProtectedAdminRoute><ProductCatalog /></ProtectedAdminRoute> : authFallback} />
                <Route path="/nl/pricing" element={<Pricing />} />
                <Route path="/nl/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/nl/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/nl/terms-sellers" element={<TermsSellers />} />
                <Route path="/nl/package" element={<Package />} />
                <Route path="/nl/balance-topup" element={<BalanceTopup />} />
                <Route path="/nl/Lifetime-Discount-Group" element={<LifetimeDiscountGroup />} />
                
                {/* German routes */}
                <Route path="/de" element={<Home />} />
                <Route path="/de/connections" element={<Connections />} />
                <Route path="/de/partners" element={<Partners />} />
                <Route path="/de/faq" element={<FAQ />} />
                <Route path="/de/contact" element={<Contact />} />
                <Route path="/de/jobs" element={<Jobs />} />
                <Route path="/de/products" element={<Products />} />
                <Route path="/de/products/:productSlug" element={<ProductDetail />} />
                <Route path="/de/p" element={clerkReady ? <ProtectedAdminRoute><ProductCatalog /></ProtectedAdminRoute> : authFallback} />
                <Route path="/de/pricing" element={<Pricing />} />
                <Route path="/de/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/de/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/de/terms-sellers" element={<TermsSellers />} />
                <Route path="/de/package" element={<Package />} />
                <Route path="/de/balance-topup" element={<BalanceTopup />} />
                <Route path="/de/Lifetime-Discount-Group" element={<LifetimeDiscountGroup />} />
                
                {/* French routes */}
                <Route path="/fr" element={<Home />} />
                <Route path="/fr/connections" element={<Connections />} />
                <Route path="/fr/partners" element={<Partners />} />
                <Route path="/fr/faq" element={<FAQ />} />
                <Route path="/fr/contact" element={<Contact />} />
                <Route path="/fr/jobs" element={<Jobs />} />
                <Route path="/fr/products" element={<Products />} />
                <Route path="/fr/products/:productSlug" element={<ProductDetail />} />
                <Route path="/fr/p" element={clerkReady ? <ProtectedAdminRoute><ProductCatalog /></ProtectedAdminRoute> : authFallback} />
                <Route path="/fr/pricing" element={<Pricing />} />
                <Route path="/fr/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/fr/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/fr/terms-sellers" element={<TermsSellers />} />
                <Route path="/fr/package" element={<Package />} />
                <Route path="/fr/balance-topup" element={<BalanceTopup />} />
                <Route path="/fr/Lifetime-Discount-Group" element={<LifetimeDiscountGroup />} />
                    </Routes>
                  </main>
                  <Footer />
                </>
              } />
            </Routes>
          </div>
        </LanguageProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App; 